// STORE
import {
  CreateNewComissionPropsT,
  UpdateComissionPropsT,
} from "@interfaces/store/comissions-store-types";
import { createEffect, createEvent, createStore } from "effector";

import { EventStateStoreT } from "@interfaces/common";

import InternalStudyComissionsService from "@services/internal-study-comissions-service";

import { ComissionsShortDataT } from "@interfaces/internal-study/comissions";
import { resetAllStates } from "@store/user-store";

// COMISSOPNS DATA
export const setComissions = createEvent<ComissionsShortDataT[]>();

export const $Comissions = createStore<ComissionsShortDataT[]>([])
  .on(setComissions, (_, newState) => newState)
  .reset(resetAllStates);

// DEPARTMENTS STATES
export const setComissionStateLoading = createEvent<boolean>();
export const setComissionStateError = createEvent<boolean>();
const setComissionStateFetched = createEvent<boolean>();
const setComissionStates = createEvent<EventStateStoreT>();

export const $ComissionsState = createStore<EventStateStoreT>({
  isLoading: true,
  error: false,
  isFetched: false,
})
  .on(setComissionStateLoading, (oldState, newState) => ({
    ...oldState,
    isLoading: newState,
  }))
  .on(setComissionStateError, (oldState, newState) => ({
    ...oldState,
    isLoading: false,
    error: true,
  }))
  .on(setComissionStateFetched, (oldState, newState) => ({
    ...oldState,
    isFetched: newState,
  }))
  .on(setComissionStates, (_, newState) => newState)
  .reset(resetAllStates);

export const fetchComissions = createEffect(
  async (companyId: number | undefined) => {
    if (companyId === undefined) {
      return setComissionStateError(true);
    }
    InternalStudyComissionsService.getAll(companyId, (err, res) => {
      if (err || !res) {
        return setComissionStateError(true);
      }
      setComissions(res.data);
      setComissionStates({
        isLoading: false,
        error: false,
        isFetched: true,
      });
    });
  }
);

export const createNewComission = createEffect<CreateNewComissionPropsT>(
  async ({
    companyId,
    title,
    order_number,
    order_date,
    chairman,
    members,
    cb,
  }) => {
    InternalStudyComissionsService.create(
      companyId,
      title,
      order_number,
      order_date,
      chairman,
      members,
      (err, res) => {
        if (err || !res) {
          return cb(err);
        }
        setComissions([...$Comissions.getState(), res.data]);
        cb(null);
      }
    );
  }
);

export const updateComission = createEffect<UpdateComissionPropsT>(
  async ({
    comissionId,
    title,
    order_number,
    order_date,
    chairman,
    members,
    cb,
  }) => {
    InternalStudyComissionsService.update(
      comissionId,
      title,
      order_number,
      order_date,
      chairman,
      members,
      (err, res) => {
        if (err || !res) {
          return cb(err);
        }
        setComissions(
          $Comissions.getState().map((comission) => {
            if (comission.id === comissionId) {
              comission.title = title;
              comission.order_number = order_number;
              comission.order_date = order_date;
              comission.chairman = chairman;
              comission.members = members;
            }
            return comission;
          })
        );
        cb(null);
      }
    );
  }
);

export const removeComission = createEffect<(p: { id: number }) => void>(
  async ({ id }) => {
    InternalStudyComissionsService.delete(id, (err, res) => {
      if (err || !res) {
        return console.error("При удалении комиссии произошла ошибка");
      }
      const comissions = $Comissions.getState();
      const comissionIndex = comissions.findIndex((c) => c.id === id);

      comissions.splice(comissionIndex, 1);
      setComissions(Array.from(comissions));
    });
  }
);
